import { createSlice } from '@reduxjs/toolkit';
import { fetchProjects } from './projectsActions';

const reducerName = 'projects';
const initialState = {
  isLoading: false,
  data: [],
  error: '',

  searchTerm: '',

  filters: {
    projectFilter: 'all',
    talentPool: [],
    createdBy: [],
    clientCompany: [],
  },
  sort: {
    element: 'created_at',
    order: 'desc',
  },
  page: {
    number: 0,
    limit: 20,
  },
  pagination: { pages: 1 },
};

const { reducer, actions: projectsActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    applyFilter: (state, { payload: { type, value } }) => {
      state.filters[type] = value;
    },

    applySort: (state, { payload: { element, order } }) => {
      state.sort.element = element;
      state.sort.order = order;
    },

    applySearchTerm: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
    },

    applyPage: (state, { payload }) => {
      state.page.number = payload?.number;
    },

    clearFilter: (state, { payload }) => {
      const { type, isMulti = false } = payload;
      state.filters[type] = isMulti ? [] : null;
    },

    clearAllFilter: (state) => {
      state.page = { ...initialState.page };
      state.filters = { ...initialState.filters };
    },
  },
  extraReducers: {
    [fetchProjects.pending]: (state, { meta }) => {
      const {
        arg: { background = false },
      } = meta;
      if (background) return;
      state.isLoading = true;
    },
    [fetchProjects.fulfilled]: (state, { payload }) => {
      state.data = payload?.data || [];
      state.pagination = payload?.meta || {};
      state.isLoading = false;
    },
  },
});

export { projectsActions };
export default reducer;
